export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "MustacheWorker.f39d8922eb2dec76dec2.worker.js");
}
